import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllMatrix = createAsyncThunk('overtime/getAllMatrix', async (_, thunkAPI) => {
  try {
    const res = await axiosInstance.get(`/admin/matrixs?limit=10&page=1&type=overtime`);

    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
